<template>
	<nav
		class="nav w100 border-bottom border-white-darker-4 elevation-2dp bg-white-base content col-offset-lg-1 col-lg-10 col-12 margin-0 display-flex align-items-center justify-content-between margin-bottom-xxtiny"
	>
		<b-router-link to="/" class="col-1">
			<bbox-icon class="icon"><icon-bossabox class="logo"></icon-bossabox></bbox-icon>
		</b-router-link>
		<slot name="navTabs" />
		<div class="position-relative nav-actions col-1 display-flex justify-content-end">
			<slot name="navActions" />
		</div>
	</nav>
</template>

<script>
import BboxIcon from './Icon.vue';
import BRouterLink from './RouterLink.vue';
import IconBossabox from '../icons/icon-bossabox.svg';

export default {
	name: 'b-nav',
	components: {
		BRouterLink,
		BboxIcon,
		IconBossabox,
	},
	data() {
		return {
			activeTab: ''
		};
	},
	props: {
		/**
		 * Listagem de tabs
		 */
		tabs: {
			type: Array
		}
	}
};
</script>

<style lang="scss" scoped>
@import '@bossabox-code/design-system/css/_variables.scss';
@import '@bossabox-code/design-system/css/spacing.scss';

.nav {
	height: 6.4rem;
}

.icon {
	transform: translate(0);
}

.logo {
	font-size: 3.9rem;
}
</style>

<docs>
    ```js
    <b-nav> 
		<template v-slot:navTabs>
			<ul>
				<b-nav-tab 
					primaryNavTab
					v-for="(tab, index) in tabs"
					:key="index" 
					:label="tab.label" 
					:link="tab.path" 
				/>
			</ul>
		</template>
		<template v-slot:navActions>
			<b-avatar-dropdown />
		</template>	
	</b-nav >
    ```
</docs>
